import { apiService } from '../services/api';

export async function recalculateLoginStreaks() {
  try {
    const response = await apiService.request({
      method: 'POST',
      url: '/users/recalculate-login-streaks'
    });
    console.log('Login streaks recalculated:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to recalculate login streaks:', error);
    throw error;
  }
}

// Make it available globally for debugging
if (typeof window !== 'undefined') {
  (window as any).recalculateLoginStreaks = recalculateLoginStreaks;
}